
import React, { Component } from "react";

export const processDomainDataLists = (dary) => {
  let tary = [];
  let cary = [];
  let sary = [];
  let lary = [];
  let pary = [];
  let sdary = [];
  let bary = [];
  dary.forEach(row => {
    if (cary.indexOf(row.properties['city']) < 0) {
      cary.push(row.properties['city']);
    }
    if (sary.indexOf(row.properties['state']) < 0) {
      sary.push(row.properties['state']);
    }
  });
  cary.sort();
  sary.sort();
  cary.unshift('Any');
  sary.unshift('Any');

  let robj = {};
  robj['cary'] = cary;
  robj['sary'] = sary;

  return robj;

  this.setState({ 'city_list': cary, 'state_list': sary });
  //, 'lok_list': lary, 'ppn_list': pary, 'bedroom_list': bary });

}

export const getDateStringFromWeek = (wk) => {
  let tdate = new Date();
  let tnow = tdate.getTime();
  let stime = tnow + (wk * 7 * 24 * 60 * 60 * 1000);
  let rdatestr = new Date(stime).toISOString().slice(0, 10);
  let robj = {};
  robj['millis'] = stime;
  robj['datestr'] = rdatestr;
  return robj;
}


export const formatSummaryCountString = (obj, count) => {
  let rary = [];
  rary.push((<span key={-1} style={{ marginLeft: "5px", marginRight: "5px", color: "black" }}><b>Count:</b></span>));
  rary.push((<span key={0}>{count}</span>));
  if (obj['weeks_cb']) {
    rary.push((<span key={1} style={{ marginLeft: "5px", marginRight: "5px", color: "black" }}><b>Check In:</b></span>));
    rary.push((<span key={2} style={{ marginLeft: "5px" }}>{obj['start_date']}</span>));
    rary.push((<span key={3} style={{ marginLeft: "5px" }}>{obj['end_date']}</span>));
  }
  if (obj['lok_cb']) {
    rary.push((<span key={4} style={{ marginLeft: "5px", marginRight: "5px", color: "black" }}><b>LOK:</b></span>));
    rary.push((<span key={5} >{obj['minlok']}-{ obj['maxlok']}</span>));
  }
  if (obj['ppn_cb']) {
    rary.push((<span key={6} style={{ marginLeft: "5px", marginRight: "5px", color: "black" }}><b>PPN:</b></span>));
    rary.push((<span key={7} >{obj['minppn']}-{obj['maxppn']}</span>));
  }
  if (obj['wildcard_cb']) {
    rary.push((<span key={8} style={{ marginLeft: "5px", marginRight: "5px", color: "black" }}><b>Search:</b></span>));
    rary.push((<span key={9} >{obj['searchterm']}</span>));
  }
  return (rary);
}



/*


function rad2degr(rad) { return rad * 180 / Math.PI; }
function degr2rad(degr) { return degr * Math.PI / 180; }
*/
/**
 * @ param latLngInDeg array of arrays with latitude and longtitude
 *   pairs in degrees. e.g. [[latitude1, longtitude1], [latitude2
 *   [longtitude2] ...]
 *
 * @ return array with the center latitude longtitude pairs in
 *   degrees.
 */
/*
function getLatLngCenter(latLngInDegr) {
  var LATIDX = 0;
  var LNGIDX = 1;
  var sumX = 0;
  var sumY = 0;
  var sumZ = 0;

  for (var i=0; i<latLngInDegr.length; i++) {
      var lat = degr2rad(latLngInDegr[i][LATIDX]);
      var lng = degr2rad(latLngInDegr[i][LNGIDX]);
      // sum of cartesian coordinates
      sumX += Math.cos(lat) * Math.cos(lng);
      sumY += Math.cos(lat) * Math.sin(lng);
      sumZ += Math.sin(lat);
  }

  var avgX = sumX / latLngInDegr.length;
  var avgY = sumY / latLngInDegr.length;
  var avgZ = sumZ / latLngInDegr.length;

  // convert average x, y, z coordinate to latitude and longtitude
  var lng = Math.atan2(avgY, avgX);
  var hyp = Math.sqrt(avgX * avgX + avgY * avgY);
  var lat = Math.atan2(avgZ, hyp);

  return ([rad2degr(lat), rad2degr(lng)]);
}
*/





// export const getActive4380Devices = () => {
//   return new Promise((resolve, reject) => {
//     let jsonrpc3 = '{"transid" : "get_configured_devices","data":{}}';
//     let url3 = "/api/request_handler/handle_request/" + jsonrpc3;
//     axios.get(url3).then(data => {
//       resolve(data);
//     }).catch(err => {
//       // console.log("in getActive4380Devices response");
//       // console.log(err);
//       reject(err);

//     });
//   });

// }


// WEBPACK FOOTER //
// ./src/components/deals/DealsDataHelper.js